export default {
  expand: 'Expansion',
  show: '收起',
  button: {
    submit: 'Submit',
    reset: 'Reset',
  },
};
